export type MessageType = string | object | []

const channelInstances: {[key: string]: BroadcastChannel} = {}

const getSingletonChannelInstance = (name: string): BroadcastChannel | null => {
  try {
    if (!channelInstances[name]) {
      channelInstances[name] = new BroadcastChannel(name)
    }
    return channelInstances[name]
  } catch (error) {
    return null
  }
}

/**
 * Creates a broadcast channel
 * @param channelName - The name of the channel to create
 * @param onMessageHandler - The function to handle messages received on the channel
 */
export const createBroadcastChannel = (
  channelName: string,
  onMessageHandler: (message: MessageType) => void
) => {
  const channel = getSingletonChannelInstance(channelName)
  if (channel && !channel.onmessage) {
    channel.onmessage = (event: MessageEvent<MessageType>) =>
      onMessageHandler(event.data)
  }
}
/**
 * Posts a message to a broadcast channel
 * @param channelName - The name of the channel to post the message to
 * @param message - The message to post to the channel
 */
export const postBroadcastChannelMessage = (
  channelName: string,
  message: MessageType
) => {
  const channel = getSingletonChannelInstance(channelName)
  channel?.postMessage(message)
}
